import {BaseTileProvider} from './base-tile-provider';
import {environment} from '../../../../environments/environment';
import {MapType} from '../../enums/map-type';
import {MapProvider} from '../../enums/map-provider.enum';
import {SettingsService} from '../../services/settings.service';

export class TomTomTileProvider extends BaseTileProvider {

  // From the environment files (not in git); the browser sends it with every tile.
  private static API_KEY = environment.tomTomApiKey || '';
  // 256 px tiles, the size every tile is drawn at (BaseTileProvider): 512 px
  // ones were shrunk to half, labels and all.
  private static URL_TOMTOM = `https://{cl}.api.tomtom.com/map/1/tile/{l}/main/{z}/{x}/{y}.{f}?tileSize=256&key=${this.API_KEY}`; // cycle [a,b,c,d], [basic, hybrid, labels], <zoom>, <x>, <y>

  getMapProvider(): string {
    return MapProvider.TOMTOM;
  }

  getMaxZoom(): number {
    // Every type but MAP draws the aerial layer, which stops at 19.
    if (SettingsService.settings.mapType !== MapType.MAP) {
      return 19;
    }
    return 22;
  }

  getUrlTemplate(mapType?: MapType): string {
    let mt = mapType;
    if (!mt) {
      mt = SettingsService.settings.mapType;
    }
    let url = '';
    switch (mt) {
      case MapType.MAP:
        url = TomTomTileProvider.URL_TOMTOM.replace('{l}', 'basic')
          .replace('{f}', 'png');
        break;
      // HYBRID too: TomTom's 'hybrid' layer is only roads and labels on a
      // transparent tile, meant to lie over imagery, so it showed no ground.
      case MapType.SATELLITE:
      case MapType.HYBRID:
      case MapType.TERRAIN:
        url = TomTomTileProvider.URL_TOMTOM
          .replace('{l}', 'sat')
          .replace('{f}', 'jpg');
        break;
    }
    return url;
  }

  getUrl(x, y, zoom, mapType?: MapType): string {
    let cycle = 'a';
    switch (((x + y) % 4)) {
      case 1:
        cycle = 'b';
        break;
      case 2:
        cycle = 'c';
        break;
      case 3:
        cycle = 'd';
        break;
    }

    return this.getUrlTemplate(mapType).replace('{cl}', cycle)
      .replace('{z}', zoom)
      .replace('{x}', x)
      .replace('{y}', y);
  }

}
